const latestVisitIndex = (visits) => visits.reduce((latest, visit, index) =>
  latest < 0 || new Date(visit.visitDate || 0) > new Date(visits[latest].visitDate || 0)
    ? index : latest, -1);

const hasValue = (value) => value !== undefined && value !== null && value !== '';

export const getSpreadsheetEgfr = (screeningData = {}) => {
  const visits = screeningData.medicalReadings || [];
  const index = latestVisitIndex(visits);
  if (index < 0) return screeningData.eGFR;
  const tests = visits[index].bloodTests || [];
  return tests.reduce((value, test) => hasValue(test.eGFR) ? test.eGFR : value, undefined);
};

export const updateSpreadsheetEgfr = (screeningData, value) => {
  const eGFR = hasValue(value) ? Number(value) : null;
  const visits = [...(screeningData.medicalReadings || [])];
  let index = latestVisitIndex(visits);
  if (index < 0) {
    const now = new Date().toISOString();
    visits.push({ visitId: `visit_${Date.now()}`, visitDate: now, bloodTests: [] });
    index = 0;
  }
  const visit = visits[index];
  const tests = [...(visit.bloodTests || [])];
  if (eGFR === null) {
    // Clear every aggregate entry so an older value in this visit cannot reappear.
    visits[index] = {
      ...visit,
      bloodTests: tests.map(test => hasValue(test.eGFR) ? { ...test, eGFR: null } : test),
    };
  } else {
    let testIndex = tests.length - 1;
    for (let i = tests.length - 1; i >= 0; i--) {
      if (hasValue(tests[i].eGFR)) { testIndex = i; break; }
    }
    if (testIndex < 0) tests.push({ testNumber: 1, timestamp: new Date().toISOString(), eGFR });
    else tests[testIndex] = { ...tests[testIndex], eGFR };
    visits[index] = { ...visit, bloodTests: tests };
  }
  return { ...screeningData, eGFR, medicalReadings: visits };
};
